import { GetJWTToken, onUserLoggedIn, HistoryPush, SetIsShowLoginDialog } from '../Interface'

let popupWindowObj = null

export const OpenPopUp = url => {
    if (popupWindowObj === null || popupWindowObj.closed) {
        popupWindowObj = window.open(url, '_blank', `toolbar=no menubar=no width=1000 height=700 left=${window.screen.width / 2 - 500} top=${window.screen.height / 2 - 350}`)
        popupWindowObj.focus()
    }
}

window.oauthCallback = async data => {
    const { message } = data

    SetIsShowLoginDialog(false)
    if (message === 'success') {
        const { token, refreshtoken } = data
        localStorage.setItem('token', token)
        localStorage.setItem('refreshtoken', refreshtoken)

        try {
            const { userId: _id, displayName, shareId, email, createdAt, admin, type, token: newToken, agreement } = await GetJWTToken(token)

            const userData = {
                _id,
                userId: displayName,
                shareId,
                displayName,
                email,
                createdAt,
                admin,
                type
            }
            onUserLoggedIn(userData, newToken, refreshtoken)
            if (!agreement) HistoryPush('/requiredBox')
        }
        catch (e) {

        }
    }
    else if (message === 'withdraw') {
        HistoryPush('/socialwithdraw')
    }
    else if (message === 'notFound') {
        HistoryPush('/socialnotfound')
    }
    else if (message === 'duplicated') {
        const { data: duplicatedEmail } = data
        HistoryPush(`/duplicated?data=${duplicatedEmail}`)
    }
}